import { onDocumentReady } from "@story/story_assets";

onDocumentReady(() => {
	const hamburger = document.querySelector('[data-expanded="false"]');
	const closeBtn = document.querySelector('[data-expanded="true"]');
	const navigation = document.querySelector('.navigation');

	function openMenu() {
		document.body.classList.add('overlay');
		navigation.classList.add('expanded');
	}

	function closeMenu() {
		document.body.classList.remove('overlay');
		navigation.classList.remove('expanded');
	}

	if (hamburger && navigation) {
		hamburger.addEventListener('click', (e) => {
			e.preventDefault();
			openMenu();
		});
	}

	if (closeBtn && navigation) {
		closeBtn.addEventListener('click', (e) => {
			e.preventDefault();
			closeMenu();
		});
	}
});
